import axios from "axios";
import { beautyBaseUrl } from "network";

const api = () =>
  axios.create({
    baseURL: `${beautyBaseUrl}/beautician`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("tokenf")}`,
    },
  });

export const getTimeSlotsApi = async (id) => {
  const res = await api().get("/time-slot?id=" + id);
  return res.data.data;
};

export const addTimeSlotApi = async (id, payload) => {
  const res = await api().post("/time-slot", { data: payload, beauticianId: id });
  return res.data.data;
};

export const updateTimeSlotApi = async (uid, id, payload) => {
  const res = await api().put(`/time-slot/${id}`, { ...payload, beauticianId: uid });
  return res.data.data;
};

export const deleteTimeSlotApi = async (id) => {
  const res = await api().delete(`/time-slot/${id}`);
  return res.data;
};
